<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-4">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-12 alinmov3">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger"
              @click="deleteManyBranches()"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push('/destinations/destinations/new')"
              v-if="canUserCreate"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Destination</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
        >
          <b-form-group class="mb-0">
            <b-input-group size="sm" class="input-search">
              <b-input-group-prepend class="pt-1 pl-1">
                <i class="flaticon-bold-magnifier"></i>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="simpleSearch"
                v-on:input="applySimpleSearch"
                type="search"
                placeholder="Search Anything..."
                class="border-none"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </div>
        <div
          class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 text-right align-self-center"
        >
          <div>
            <div class="box-buttons"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2 mt-3"
        ></div>

        <div
          class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
        >
          <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
            <b-form-group
              label="Sort"
              label-for="sort-by-select"
              label-cols-sm="2"
              label-align-sm="right"
              label-size="sm"
              v-slot="{ ariaDescribedby }"
              class=""
              size="sm"
            >
              <b-input-group>
                <b-form-select
                  id="sort-by-select"
                  v-model="sortBy"
                  :options="sortOptions"
                  :aria-describedby="ariaDescribedby"
                  @change="applySortBy"
                  class="w-70"
                  size="sm"
                >
                  <template #first>
                    <option value="">-- None --</option>
                  </template>
                </b-form-select>

                <b-form-select
                  v-model="sortDesc"
                  :disabled="!sortBy"
                  :aria-describedby="ariaDescribedby"
                  @change="applySortType"
                  class="w-30"
                  size="sm"
                >
                  <option :value="'asc'">Asc</option>
                  <option :value="'desc'">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </div>
          <base-button
            type="outline-neutral"
            class="min-button mb-xl-0 mb-1"
            @click="viewCard"
          >
            <i class="flaticon-menu"></i>
            View Card
          </base-button>
          <base-dropdown
            v-if="canUserExport"
            menu-on-right
            class="nav-item"
            tag="li"
            title-tag="a"
            title-classes="btn min-button btn-outline-neutral mb-xl-0 mb-1"
            title="Actions"
          >
            <base-button slot="title" type="none" class="p-0 min-button">
              <i class="flaticon-downloading-files"></i>
            </base-button>
            <div
              class="dropdown-item"
              @click="download(selectedRows)"
              v-if="selectedRows.length > 0"
            >
              Selected Records
            </div>
            <div class="dropdown-item" @click="download([])">All Records</div>
          </base-dropdown>
          <div class="d-inline-block">
            <el-tooltip content="Help" placement="bottom">
              <base-button
                type="outline-neutral"
                class="btn-icon-only mb-0"
                @click="openSideBar"
              >
                <i class="flaticon-question-1 f-16 mr-0"></i>
              </base-button>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div>
        <pagination-block
          :pageCount="responseBranch.pages"
          v-model="currentPage"
          :total="responseBranch.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="responseBranch.docs"
          :fields="fields"
          sort-by.sync="name"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == branches.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #cell(name)="data">
            <router-link
              class="capitalize hide-data"
              :to="`/destinations/destination/${data.item._id}`"
              >{{ data.item.name }}
            </router-link>
          </template>

          <template #cell(supplier)="data">
            <div class="d-flex align-items-center">
              <span class="hide-data d-inline-flex" v-if="data.item.supplier">{{
                data.item.supplier.businessDetails.name
              }}</span>

              <el-tooltip
                content="Affiliate"
                placement="bottom"
                v-if="isAffiliate(data.item.supplier)"
              >
                <i
                  class="flaticon-checkmark text-success d-inline-flex ml-1 f2"
                ></i>
              </el-tooltip>
            </div>
          </template>

          <template #cell(phone)="data">
            <span class="hide-data">{{ data.item.phone }}</span>
          </template>

          <template #cell(email)="data">
            <a
              class="hide-data"
              :href="
                `https://mail.google.com/mail/?view=cm&fs=1&to=${data.item.email}`
              "
              target="_blank"
              >{{ data.item.email }}</a
            >
          </template>

          <template #cell(address)="data">
            <span class="role-table">{{ data.item.country }}</span>
            <span class="hide-data hide-150">{{ data.item.address }}</span>
          </template>

          <template #cell(hours_advance_booking)="data">
            <span class="hide-data">{{ data.item.hours_advance_booking }}</span>
          </template>
          <template #cell(actions)="data">
            <el-tooltip content="Edit" placement="bottom">
              <router-link
                class="icon-action text-blue"
                :to="`/destinations/destination/${data.item._id}`"
              >
                <i class="flaticon-pencil text-primary"></i>
              </router-link>
            </el-tooltip>

            <el-tooltip content="Coverage Areas" placement="bottom">
              <span
                class="icon-action text-new ml-2"
                @click="
                  $router.push(`/destination/${data.item._id}/coverage-areas`)
                "
              >
                <i class="flaticon-radar"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Rates" placement="bottom">
              <span
                class="icon-action text-warning ml-2"
                @click="$router.push(`/destination/${data.item._id}/rates`)"
              >
                <i class="flaticon-bold-list"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                class="icon-action text-danger ml-2"
                @click="deleteBranch(data.item._id)"
                v-if="canUserDelete"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>

        <pagination-block
          :pageCount="responseBranch.pages"
          v-model="currentPage"
          :total="responseBranch.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { BranchesAPI, ExportAPI, DocumentsAPI } from "../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import {
  goBack,
  isUserAuthorized,
  setSigOut
} from "../../../helpers/commons.helpers";
export default {
  name: "Destinations",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      currentPage: 1,
      limit: 0,
      selectedRows: [],
      currentRow: null,
      loading: true,
      modal: false,
      query: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "name",
          label: "Destination",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "supplier",
          label: "Supplier",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "text-left"
        },
        {
          key: "phone",
          label: "Phone N°",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: { minWidth: "220px" },
          class: "text-left"
        },

        {
          key: "address",
          label: "Address",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },

        {
          key: "hours_advance_booking",
          label: "Hrs. Advanced",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "90px" }
        }
      ],
      cardview: false,
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        {
          value: "name",
          text: "Destination"
        },
        {
          value: "email",
          text: "Email"
        },
        {
          value: "country",
          text: "Country"
        },
        { value: "created_at", text: "Created At" }
      ],
      timeoutId: null,
      guides: [],
      loader: false,
      visibleSideBar: false
    };
  },

  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Destinations",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.getOperatorsOptions();
    this.getSesion();
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.branchSearchCriteria.currentPage;
    this.query = this.branchSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    preventPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    async deleteBranch(branchId) {
      let { value } = await Swal.fire({
        title: "Delete Destination",
        text: "Are you sure do you want to delete this Destination?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteBranchById(branchId);
      }
    },
    async deleteBranchById(branchId) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.deleteBranchById(
          branchId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(false, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Brach has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteManyBranches() {
      let { value } = await Swal.fire({
        title: "Delete Destinations",
        text: "Are you sure do you want to delete the selected destinations?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyBranchesById(this.selectedRows);
      }
    },
    async deleteManyBranchesById(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await BranchesAPI.deleteManyBranchesById(
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(false, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The destinations has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(branches = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVBranches(
          { branches: branches },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `destinations-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.limit, 1, this.query);
        }
      }, 500);
    },
    get(loader, limit, page, query) {
      this.setBranchSearchCriteria({
        currentPage: page,
        limit: limit,
        page: page,
        query: query,
        status: true
      });
      this.getBranches({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },

    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    viewCard() {
      if (this.cardview === true) {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    isAffiliate(supplier) {
      if (supplier) {
        return supplier ? supplier.affiliate : false;
      } else {
        return false;
      }
    },
    isInBranchModule(modules = []) {
      if (!(modules.indexOf("destinations") > -1)) {
        this.setBranchSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
    },
    getTimeFormat(time) {
      if (time >= 1 && time <= 12) {
        return time === 1 ? `${time} hour` : `${time} hours`;
      } else {
        return time / 24 === 1 ? `${time / 24} day` : `${time / 24} days`;
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "DESTINATIONS");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapActions([
      "getBranches",
      "getOperatorsOptions",
      "getSesion",
      "getSearchBranches",
      "getLimit"
    ]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setBranchSearchCriteria"
    ])
  },
  computed: {
    branches: function() {
      if (this.responseBranch.docs) {
        return this.responseBranch.docs;
      } else {
        return [];
      }
    },
    ...mapGetters([
      "responseBranch",
      "sesion",
      "userRole",
      "paginationLimit",
      "branchSearchCriteria"
    ]),
    canUserDelete() {
      return isUserAuthorized("DESTINATIONS", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("DESTINATIONS", this.userRole, "CREATE");
    },
    canUserExport() {
      return isUserAuthorized("DESTINATIONS", this.userRole, "EXPORT");
    }
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  beforeRouteLeave(to, from, next) {
    this.isInBranchModule(to.meta.modules);
    next();
  }
};
</script>
